exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer-1s7i2{position:fixed;z-index:1000;background-color:#b4bfd5;width:100%;color:#565e85;font-size:16px;text-align:center}.content-gs_Q1{padding:20px 0;max-width:1800px;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.content-gs_Q1 a,.content-gs_Q1 .link--37kk{color:#373865;cursor:pointer}.content-gs_Q1 h4{margin:0 0 15px}.content-gs_Q1 p{margin:10px 0}.item-1d5Pb{padding:0 20px;position:relative}.button-3CMQC{width:170px;margin-top:10px}", ""]);

// exports
exports.locals = {
	"disclaimer": "disclaimer-1s7i2",
	"content": "content-gs_Q1",
	"link": "link--37kk",
	"item": "item-1d5Pb",
	"button": "button-3CMQC"
};